import {Platform} from 'react-native';
import getConfig from './getConfig';

export default function shouldAutoFocus(autoFocus?: boolean) {
  if (!autoFocus) {
    return false;
  }

  if (Platform.OS !== 'ios') {
    return true;
  }

  return Boolean(getConfig('ENABLE_IOS_AUTOFOCUS'));
}
